export default __webpack_public_path__ + "static/media/edit-dark-accent.f10c3fba.svg";